import { Injectable } from '@angular/core';
import { DataEntryEmailDto } from '@osos/shared/api';
import { EntryEmailsPresenterModel } from '@osos/shared/types';
import { ParserBase } from '../../bases';

@Injectable()
export class EntryEmailsParserV1Service extends ParserBase<
  DataEntryEmailDto,
  EntryEmailsPresenterModel
> {
  constructor() {
    super(DataEntryEmailDto, EntryEmailsPresenterModel, 1);
  }
  getPresenterModel(model: DataEntryEmailDto): EntryEmailsPresenterModel {
    return {
      ...model,
    } as EntryEmailsPresenterModel;
  }
  getDataModel(presenter: EntryEmailsPresenterModel): DataEntryEmailDto {
    const model = {
      ...presenter,
    } as DataEntryEmailDto;

    return model;
  }
}
